export const toBuurtbase = (path: string) => {
  const BUURTBASE_URL =
    process.env.REACT_APP_BUURTBASE_URL || window.location.href
  return new URL(path, BUURTBASE_URL).toString()
}
